import routes from 'routes';

/** Session-scoped hint for post-load navigation; cleared on login/logout to avoid stale redirects. */
export const GEN_TAX_CALLED_PAGE_KEY = 'genTaxCalledPage';

/** Pages that should not be restored via genTaxCalledPage (settings / legal). */
export const isNonRestorableCalledPage = (path: string): boolean => {
  if (!path) return true;
  return (
    path === routes.accessibility ||
    path === routes.accessibilityStatement ||
    path.startsWith(`${routes.accessibility}/`) ||
    path.startsWith(`${routes.accessibilityStatement}/`)
  );
};

export const clearGenTaxCalledPage = (): void => {
  try {
    localStorage.removeItem(GEN_TAX_CALLED_PAGE_KEY);
  } catch {
    // ignore quota / private mode
  }
};

export const checkPageLoaded = (
  pathname: string,
  rootPath: string | null = null
) => {
  const calledPage = localStorage.getItem(GEN_TAX_CALLED_PAGE_KEY);
  if (calledPage) {
    // Stale settings/legal URLs must not hijack navigation to Entities etc.
    if (isNonRestorableCalledPage(calledPage)) {
      localStorage.removeItem(GEN_TAX_CALLED_PAGE_KEY);
      return false;
    }
    if (calledPage === pathname) {
      localStorage.removeItem(GEN_TAX_CALLED_PAGE_KEY);
    } else {
      if (
        rootPath &&
        pathname.includes(rootPath) &&
        !calledPage.includes(routes.main)
      ) {
        window.location.href = calledPage;
      }
    }
  }
  return false;
};
